<ng-template #bottomSheetTemplate>
  <div class="error" *ngIf="error">
    <div class="header d-flex gap-2 align-items-center justify-content-between">
      <h3>{{ error.title }}</h3>
      <div
        class="need-help"
        *ngIf="needhelp || error.code === 'error' || error.code === 'unknown_error'"
      >
        <button
          mat-icon-button
          i18n-matTooltip="@@CallToAction.NeedHelp"
          matTooltip=" Need Help? "
          xNeedHelp
        >
          <fa-icon icon="question" xIconColor="primary" xIconSize="large"></fa-icon>
        </button>
      </div>
    </div>
    <div class="body mt-1">
      <div class="message">{{ error.message }}</div>
    </div>
    <div class="actions d-flex gap-2 mt-3" (click)="closeBottomSheet()">
      <ng-content select="[xAction]"></ng-content>
    </div>
  </div>
</ng-template>
